export default "__VITE_ASSET__f2yLYy_Y__"